import { iconsWebApp } from '../../constants/searchAssets'
import { icons } from '../../constants/searchAssets'
import { TabItem } from '../../components/TabItem'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import React from 'react'
import { Coordinator } from '../../navigation/coordinator/coordinator'

interface TabItemProps {
  onPress: () => void
  source: HTMLImageElement
  description: string
}

export const BottomMenuTabs: React.FunctionComponent = React.memo(({}) => {
  const dataMenu = [
    {
      source: icons.monetizationDashboard,
      description: formatMessage(messages.dashboard_bottomTabs_fin),
      onPress: Coordinator.goToFinance,
    },
    {
      source: icons.homeDashboard,
      description: formatMessage(messages.dashboard_bottomTabs_constructions),
      onPress: Coordinator.goToConstructions,
    },
    {
      source: icons.assistanceDashboard,
      description: formatMessage(messages.dashboard_bottomTabs_assistance),
      onPress: Coordinator.goToAssistance,
    },
    {
      source: icons.rangeDashboard,
      description: formatMessage(messages.dashboard_bottomTabs_appointments),
      onPress: Coordinator.goToAppointments,
    },
    {
      source: icons.alertDashboard,
      description: formatMessage(messages.dashboard_bottomTabs_notifications),
      onPress: Coordinator.goToNotificationsScreen,
    },
    {
      source: icons.profileDashboard,
      description: formatMessage(messages.dashboard_bottomTabs_profile),
      onPress: Coordinator.goToProfile,
    },
  ]
  return (
    <>
      {dataMenu.map((value: TabItemProps, index: number) => (
        <TabItem key={index} source={value.source} description={value.description} onPress={value.onPress} />
      ))}
    </>
  )
})
